import { NavLink, Navigate, Outlet, Route, Routes } from "react-router-dom";
import { AdminOptimizerConfigsPage } from "./AdminOptimizerConfigsPage";

// AdminPage — wrapper de la sección Administración. Renderiza un layout
// con sidebar de sub-secciones y delega el contenido al sub-router.
//
// Hoy solo "Configuraciones del optimizador" está implementado, pero
// la estructura permite sumar Tipos de vehículo, Motivos de rechazo,
// Horarios, etc. sin rediseñar la navegación.
export function AdminPage() {
  return (
    <div className="flex h-full">
      <aside className="w-56 border-r border-border bg-card flex-shrink-0">
        <div className="px-4 py-3 border-b border-border">
          <div className="text-xs uppercase tracking-wide text-sub">Administración</div>
        </div>
        <nav className="p-2 space-y-1">
          <AdminNavItem to="optimizer-configs" label="Configuraciones del optimizador" />
        </nav>
      </aside>
      <main className="flex-1 overflow-auto">
        <Routes>
          <Route index element={<Navigate to="optimizer-configs" replace />} />
          <Route path="optimizer-configs" element={<AdminOptimizerConfigsPage />} />
        </Routes>
        <Outlet />
      </main>
    </div>
  );
}

function AdminNavItem({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `block px-3 py-2 text-sm rounded transition-colors ${
          isActive
            ? "bg-primary/10 text-primary font-medium"
            : "text-ink hover:bg-page"
        }`
      }
    >
      {label}
    </NavLink>
  );
}
